import { render } from "./Import_Appointments.vue?vue&type=template&id=73be3f50"
import script from "./Import_Appointments.vue?vue&type=script&lang=js"
export * from "./Import_Appointments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__